import $ from "jquery";
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

$( () => {
    const swiper = new Swiper('.swiper', {
        modules: [ Navigation ],
        pagination: false,
        centeredSlides: true,
        centerInsufficientSlides: true,
        spaceBetween: 25,
        cssMode: true,
        grabCursor: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        }
    });
});